'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _path2 = require('ramda/src/path');

var _path3 = _interopRequireDefault(_path2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    resize: none;\n    max-width: 100%;\n    height: auto;\n    vertical-align: bottom;\n    min-height: 36px;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    position: relative;\n    display: inline-block;\n    padding: 6px 11px !important;\n    width: 100%;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 1.5;\n    color: rgba(0,0,0,.65);\n    box-shadow: none;\n    background-color: #fff;\n    background-image: none;\n    border: 1px solid #d1dbe7;\n    border-radius: 1px;\n    box-sizing: border-box;\n    transition: all .3s, height 0s;\n    &:hover,&:focus {\n        border-color: #a3b8d0 !important;\n    }\n    &:focus{\n        outline: 0;\n        box-shadow: none !important;\n    }\n    &[disabled] {\n        background-color: #f5f5f5;\n        opacity: 1;\n        cursor: not-allowed;\n        color: #000;\n        &:hover {\n            border-color: #d9d9d9;\n        }\n    }\n    &::before {\n        display: inline-block;\n        position: absolute;\n        content: \'0/100\';\n        top: 0px;\n        right: 0px;\n    }\n    ::placeholder {\n        color: #bfbfbf !important;\n    }\n    ::-ms-input-placeholder {\n        color: rgba(0,0,0,.5) !important;\n    }\n    :-ms-input-placeholder {\n        color: #bfbfbf !important;\n    }\n'], ['\n    resize: none;\n    max-width: 100%;\n    height: auto;\n    vertical-align: bottom;\n    min-height: 36px;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    position: relative;\n    display: inline-block;\n    padding: 6px 11px !important;\n    width: 100%;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 1.5;\n    color: rgba(0,0,0,.65);\n    box-shadow: none;\n    background-color: #fff;\n    background-image: none;\n    border: 1px solid #d1dbe7;\n    border-radius: 1px;\n    box-sizing: border-box;\n    transition: all .3s, height 0s;\n    &:hover,&:focus {\n        border-color: #a3b8d0 !important;\n    }\n    &:focus{\n        outline: 0;\n        box-shadow: none !important;\n    }\n    &[disabled] {\n        background-color: #f5f5f5;\n        opacity: 1;\n        cursor: not-allowed;\n        color: #000;\n        &:hover {\n            border-color: #d9d9d9;\n        }\n    }\n    &::before {\n        display: inline-block;\n        position: absolute;\n        content: \'0/100\';\n        top: 0px;\n        right: 0px;\n    }\n    ::placeholder {\n        color: #bfbfbf !important;\n    }\n    ::-ms-input-placeholder {\n        color: rgba(0,0,0,.5) !important;\n    }\n    :-ms-input-placeholder {\n        color: #bfbfbf !important;\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    position: relative;\n\n    textarea {\n        ', '\n    }\n'], ['\n    position: relative;\n\n    textarea {\n        ', '\n    }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    position: absolute;\n    bottom: 1px;\n    right: 1px;\n    line-height: 14px;\n    z-index: 1;\n    color: #bfbfbf;\n    background: transparent;\n    padding: 0 2px;\n'], ['\n    position: absolute;\n    bottom: 1px;\n    right: 1px;\n    line-height: 14px;\n    z-index: 1;\n    color: #bfbfbf;\n    background: transparent;\n    padding: 0 2px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

require('antd/lib/input/style/index.css');

var _withFieldWrapper = require('../hocs/withFieldWrapper');

var _withFieldWrapper2 = _interopRequireDefault(_withFieldWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Textarea = (0, _styledComponents2.default)(_input2.default.TextArea)(_templateObject);

var InputWrapper = _styledComponents2.default.div(_templateObject2, function (_ref) {
    var hasMinLength = _ref.hasMinLength;
    return hasMinLength ? '\n            padding-bottom: 20px;\n        ' : '';
});

var InputLength = _styledComponents2.default.div(_templateObject3);

var TextareaComponent = function (_Component) {
    _inherits(TextareaComponent, _Component);

    function TextareaComponent() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, TextareaComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = TextareaComponent.__proto__ || Object.getPrototypeOf(TextareaComponent)).call.apply(_ref2, [this].concat(args))), _this), _this.onChange = function (e) {
            return _this.props.onChange(e.target.value);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TextareaComponent, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                item = _props.item,
                value = _props.value,
                disabled = _props.disabled,
                label = _props.label;

            var length = (0, _path3.default)(['length'], value) || 0;
            var minLength = (0, _path3.default)(['min_length'], item) || 0;

            return _react2.default.createElement(
                InputWrapper,
                { hasMinLength: false },
                minLength ? _react2.default.createElement(
                    InputLength,
                    null,
                    length,
                    '/',
                    minLength
                ) : null,
                _react2.default.createElement(Textarea, {
                    value: value || '',
                    placeholder: label,
                    onChange: this.onChange,
                    disabled: disabled,
                    autoSize: disabled ? { minRows: 1 } : { minRows: 1, maxRows: 20 }
                })
            );
        }
    }]);

    return TextareaComponent;
}(_react.Component);

TextareaComponent.propTypes = {
    label: _propTypes2.default.string,
    value: _propTypes2.default.string,
    item: _propTypes2.default.object,
    onChange: _propTypes2.default.func,
    disabled: _propTypes2.default.bool
};
exports.default = (0, _withFieldWrapper2.default)(TextareaComponent);